import React, { useEffect, useState } from 'react';

import { ChoghadiyaNames } from '../../utils/choghadiya-table';
import {
  getChoghadiyaData,
  goodAuspiciousChoghadiya,
  getLabelArr,
} from '../../utils/helper';

import './Timings.scss';

type TableProps = {
  isNightChecked: boolean;
  timingsArr: string[];
  today: string;
};

const Timings = ({ isNightChecked, timingsArr, today }: TableProps) => {
  const selectedDate = new Date(today);
  const [day, setDay] = useState(selectedDate.getDay());

  const [labelArr, setLabelArr] = useState<ChoghadiyaNames[]>([]);

  useEffect(() => {
    setDay(selectedDate.getDay());
  }, [today]);

  useEffect(() => {
    setLabelArr(getLabelArr(isNightChecked, day) || []);
  }, [day, isNightChecked]);

  return (
    <div className="pachkhan-table">
      <div className="table-wrapper">
        <table>
          <tbody>
            {getChoghadiyaData(labelArr, timingsArr).map((row, index) => (
              <tr key={index}>
                <td
                  className={`label-cell ${
                    goodAuspiciousChoghadiya.includes(row.label)
                      ? 'label-cell-good'
                      : 'label-cell-bad'
                  }`}
                >
                  {row.label}
                </td>
                <td className="value-cell">
                  {timingsArr.length > 0 ? row.value : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Timings;
